import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSessionFacade } from '@services/auth-session/auth-session.facade';
import { CLEAR_AUTH_SESSION } from '@store/user/user.action';
import { UserState } from '@store/user/user.state';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  const authSessionFacade = inject(AuthSessionFacade);

  const user = store.selectSnapshot(UserState.user);
  if (user?.userId) {
    authSessionFacade.setSession(user, route.queryParams);
    if (authSessionFacade.hasSession()) {
      return true;
    }
    store.dispatch(new CLEAR_AUTH_SESSION());
  }

  if (canBootstrapSession(route)) {
    return true;
  }

  return router.createUrlTree(['/404']);
};

function canBootstrapSession(route: ActivatedRouteSnapshot): boolean {
  return route.routeConfig?.path === 'home' && !!route.queryParamMap.get('token')?.trim();
}
